import { useEffect } from 'react';
import { observer } from 'mobx-react';

import track from 'services/tracking';
import FirebaseStore from 'stores/FirebaseStore';
import ProfileStore from 'stores/ProfileStore';
import UserStore from 'stores/UserStore';
import allUserGroups from 'enum/userGroups';


function TrackCam2CamProfile() {
  const { shouldSendC2CMetric } = FirebaseStore;
  const { isLoggedIn, hasCF, user } = UserStore;
  const isC2CViewer = hasCF(allUserGroups.CAM2CAM_VIEWER);
  const shouldTrack = isLoggedIn && isC2CViewer && shouldSendC2CMetric;

  useEffect(() => {
    if (shouldTrack) {
      track({
        eventname: 'c2cEnabledRoom',
        username: user.username,
        room: ProfileStore.profileName,
      });
    }
  }, [shouldSendC2CMetric, shouldTrack, user.username]);

  return null;
}

export default observer(TrackCam2CamProfile);
